// Layout
import Layout from "@views/layout/Layout";
import Privacy from "@views/privacy/Privacy";
import Terms from "@views/terms/Terms";
import admin from "./admin";
import clients from "./clients";
import login from "./login";

export default [
    ...login,

    {
        path: "/",
        component: Layout,
        redirect: "/visao-geral",
        children: [...admin, ...clients]
    },

    {
        path: "*",
        redirect: "/visao-geral"
    },

    {
        name: "Privacy",
        path: "/privacidade",
        component: Privacy,
        meta: { requiresAuth: false }
    },

    {
        name: "Terms",
        path: "/termos",
        component: Terms,
        meta: { requiresAuth: false }
    }
];
